import React from 'react';
import GameStats from '../../GameStats.js';
export default function GameHeaderWithInstructions({ navigationButton, instruction, game, scenario, playerInfo, }) {
    return (React.createElement("div", { className: "game-header-with-instructions" },
        React.createElement("div", { className: "game-header" },
            navigationButton,
            React.createElement(GameStats, { game: game, playerA: playerInfo.playerA, playerB: playerInfo.playerB, scenario: scenario })),
        React.createElement("div", { className: `game-instructions has-text-black ${playerInfo.isCurrentUserPlayerActive
                ? 'has-background-warning'
                : 'has-background-grey-lighter'}` }, instruction)));
}
